import { useMemo } from "react";
import {
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Tag,
  TagLabel,
  TagCloseButton,
  Wrap,
  WrapItem,
  IconButton,
  Tooltip,
} from "@chakra-ui/react";
import { HiSearch, HiX } from "react-icons/hi";

export default function DefinitionsFilterBar({
  definitions,
  selectedCollection,
  selectedType,
  searchText,
  onTypeChange,
  onSearchChange,
  onClearFilters,
}) {
  // Get unique types filtered by selected collection
  const availableTypes = useMemo(() => {
    const filteredDefs = selectedCollection
      ? definitions.filter((def) => def.collection === selectedCollection)
      : definitions;

    const types = [...new Set(filteredDefs.map((def) => def.type).filter(Boolean))];
    return types.sort();
  }, [definitions, selectedCollection]);

  const hasActiveFilters =
    selectedCollection || selectedType || searchText.trim().length > 0;

  return (
    <HStack spacing={3} align="flex-start" wrap="wrap">
      {/* Search box */}
      <InputGroup maxW="300px" size="sm">
        <InputLeftElement pointerEvents="none">
          <HiSearch color="gray.300" />
        </InputLeftElement>
        <Input
          placeholder="Search definitions..."
          value={searchText}
          onChange={(e) => onSearchChange(e.target.value)}
          bg="white"
        />
      </InputGroup>

      {/* Type filter */}
      <Select
        placeholder="All Types"
        size="sm"
        maxW="250px"
        value={selectedType || ""}
        onChange={(e) => onTypeChange(e.target.value || null)}
        bg="white"
        disabled={availableTypes.length === 0}
      >
        {availableTypes.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </Select>

      {/* Active filter chips */}
      {hasActiveFilters && (
        <Wrap spacing={2} align="center">
          {selectedCollection && (
            <WrapItem>
              <Tag size="sm" colorScheme="blue" variant="solid">
                <TagLabel>Collection: {selectedCollection}</TagLabel>
              </Tag>
            </WrapItem>
          )}
          {selectedType && (
            <WrapItem>
              <Tag
                size="sm"
                colorScheme="purple"
                variant="solid"
                cursor="pointer"
                onClick={() => onTypeChange(null)}
              >
                <TagLabel>Type: {selectedType}</TagLabel>
                <TagCloseButton />
              </Tag>
            </WrapItem>
          )}
          {searchText.trim().length > 0 && (
            <WrapItem>
              <Tag
                size="sm"
                colorScheme="green"
                variant="solid"
                cursor="pointer"
                onClick={() => onSearchChange("")}
              >
                <TagLabel>Search: "{searchText}"</TagLabel>
                <TagCloseButton />
              </Tag>
            </WrapItem>
          )}

          {/* Clear all button */}
          <WrapItem>
            <Tooltip label="Clear all filters">
              <IconButton
                icon={<HiX />}
                size="sm"
                variant="ghost"
                colorScheme="red"
                aria-label="Clear all filters"
                onClick={onClearFilters}
              />
            </Tooltip>
          </WrapItem>
        </Wrap>
      )}
    </HStack>
  );
}
